import { useSelector } from "@xstate5/vue";
import { waitFor } from "xstate5";
import { isFeatureFlagEnabled } from "../../../shared/lib/posthog";
import { permissionsActor } from "../state-machines/get-admin-permissions";

export function usePermission() {
	const rolesAndPermissionsFeatureFlag = isFeatureFlagEnabled(
		"roles-and-permissions",
	);

	const permissions = useSelector(
		permissionsActor,
		(snapshot) => snapshot.context.permissions,
	);

	/**
	 * Get user permissions from permissions actor
	 */
	async function getUserPermissions() {
		const snapshot = await waitFor(
			permissionsActor,
			(snapshot) => ["success", "error"].includes(snapshot.value),
			{
				timeout: 30000,
			},
		);
		return snapshot.context.permissions;
	}

	/**
	 * If roles-and-permissions feature flag is disabled in posthog, always return true
	 * Otherwise, check if user permissions has the required permission
	 * @param userPermissions
	 * @param requiredPermissionId
	 * @returns
	 */
	function hasPermission(
		userPermissions: Record<string, boolean>,
		requiredPermissionId: string,
		byPassFeatureFlag = false,
	) {
		// TODO: remove this once we have role and permissions feature enabled for all users
		// VITE_ENV "local" to allow local development
		if (
			(!byPassFeatureFlag && !rolesAndPermissionsFeatureFlag) ||
			import.meta.env.VITE_ENV === "local"
		) {
			return true;
		}
		return userPermissions[requiredPermissionId] ?? false;
	}

	/**
	 * Check if user is institution admin
	 */
	function isInstitutionAdmin() {
		// TODO: This is a temporary solution.
		// For now, we assume that all users are institution admins.
		// In the future, we have incorporated roles and permissions
		// and then isInstitutionAdmin will be computed based on user's role.
		const isInstitutionAdmin = true;
		return isInstitutionAdmin;
	}

	return {
		getUserPermissions,
		hasPermission,
		permissions,
		isInstitutionAdmin,
	};
}
